import TextNavBackground from "../components/common/TextNavBackground";
import { apiWrapper } from "../utils/api/apiWrapper";
import { kFAQsURL } from "../utils/constants/apiUrls";
import { THREE_MONTH_REFRESH_INTERVAL_SECONDS } from "../utils/constants/numbers";
import MarkdownRender from "../components/common/MarkdownRender";
import { customStaticSeoConfig, getApiToken } from "../utils/helpers/helpers";
import { TERMS_AND_CONDITIONS_URL } from "../utils/constants/websiteUrls";
import { TabNoData } from "../components/common/NoData";

const FAQs = ({ faqs }) => {
  // SAFE FIX: Provide an empty object default to prevent top-level destructuring crashes
  const { faqs: faqsInfo = "" } = faqs || {};

  const url = TERMS_AND_CONDITIONS_URL;

  return (
    <>
      {customStaticSeoConfig("FAQs")}
      <TextNavBackground title="FAQs" />

      {faqsInfo === "" && <TabNoData />}

      {faqsInfo !== "" && (
        <MarkdownRender
          title={"Asante Kotoko SC FAQs"}
          caption={
            "Frequently Asked Questions about the Asante Kotoko website and app."
          }
          url={url}
          markdownData={faqsInfo}
        />
      )}
    </>
  );
};

export default FAQs;

export const getStaticProps = async (context) => {
  const token = getApiToken();
  const faqs = await apiWrapper.get(kFAQsURL, token);

  return {
    props: {
      // SAFE FIX: Pass an empty object fallback down to preserve properties safely
      faqs: faqs?.data || {},
    },
    revalidate: THREE_MONTH_REFRESH_INTERVAL_SECONDS,
  };
};
